import { render } from "./ContactsListPage.vue?vue&type=template&id=2bbb804a&ts=true"
import script from "./ContactsListPage.vue?vue&type=script&lang=ts"
export * from "./ContactsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__